<div class="issue-type">

    <sc-master-detail [selection]="[selected]" [data]="issueTypes" [newStyle]="true"
        (selectionChanged)="onSelectionChanged($event);" 
        (addEntry)="onAddEntry($event);" (deleteEntry)="onDeleteEntry($event);">
        <form #displayForm="ngForm" class="form">

            <div class="issue-type-details" *ngIf="workingCopyDetails">
                <div class="scrollable">
                    <div class="form-box grid">

                        <sc-dictionary-field style="grid-column: 1; grid-row: 1;" [model]="workingCopyDetails.name"
                            [defaultLabel]="'name'" [labelDictionaryKey]="'tmc.admin.issue-type.name'" [required]="true"
                            [maxlength]="255" (dictionaryChanged)="onDictionaryChanged()">
                        </sc-dictionary-field>

                        <mat-form-field style="grid-column: 1; grid-row: 2;">
                            <input [(ngModel)]="workingCopyDetails.delay" name="delay" matInput
                                placeholder="{{'delay' | translate: ['tmc.admin.issue-type.delay', translationService.language]}}"
                                [required]="true" type="number" appPositiveInteger min="0" />
                        </mat-form-field>

                        <mat-form-field style="grid-column: 1; grid-row: 3;">
                            <input [(ngModel)]="workingCopyDetails.sortOrder" name="sortOrder" matInput
                                placeholder="{{'sort order' | translate: ['tmc.admin.issue-type.sortOrder', translationService.language]}}"
                                [required]="false" [maxlength]="10" [minlength]="0" />
                        </mat-form-field>

                    </div>
                </div>
            </div>

        </form>

        <ng-template masterDetailToolbar>
            <button mat-stroked-button type="button" class="config-changed-button" (click)="cancel()"
                [disabled]="!cancelEnabled">{{'cancel'
                | translate: ['tmc.admin.issue-type.action.cancel', translationService.language]}}</button>
            <sc-content-spacer></sc-content-spacer>
            <button mat-flat-button type="button" class="config-changed-button" (click)="save()"
                [disabled]="!saveEnabled">{{'save' | translate: ['tmc.admin.issue-type.action.save',
                translationService.language]}}</button>
        </ng-template>

    </sc-master-detail>



</div>